import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import DownloadIcon from '../../images/download.svg';

const DownloadButton = ({ children, isLoading, onClick, style, ...rest }) => {
  return (
    <button
      className="blue-button-teams"
      style={{ width: '10rem', alignSelf: 'auto', ...style }}
      onClick={onClick}
      disabled={isLoading}
      {...rest}
    >
      {isLoading ? <Spinner animation="border" size="sm" /> : <img src={DownloadIcon} alt="Download" />} {children}
    </button>
  );
};

DownloadButton.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default DownloadButton;
